import React, { createContext, useState, useEffect } from 'react';
import userManager from '../auth/authService';
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import {setupApiInterceptors} from "../apiClient/setupApiInterceptors";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    //oidc
    const [user, setUser] = useState(null);
    const [userLoaded, setUserLoaded] = useState(false);

    //fingerprint
    const [visitorId, setVisitorId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        //oidc
        userManager.getUser().then(u => {
            if (u && !u.expired) setUser(u);
        }).finally(() => setUserLoaded(true));

        //fingerprint
        const loadFingerprint = async () => {
            try {
                const fp = await FingerprintJS.load();
                const result = await fp.get();
                // Install the header before the state change: effects of consumers (the usage
                // request) run before this provider's own effects would.
                setupApiInterceptors(result.visitorId);
                setVisitorId(result.visitorId);
            } catch (err) {
                console.error("Fingerprint failed", err);
            } finally {
                setLoading(false);
            }
        };

        setupApiInterceptors(null);
        loadFingerprint();

    }, []);

    const login = () =>
        userManager.signinRedirect({
            state: {returnUrl: window.location.href},
        });

    const logout = () => {
        sessionStorage.setItem('postLogoutReturnUrl', window.location.href);
        userManager.signoutRedirect();
    };

    // The API identifies the caller by fingerprint and token, so requests that depend on
    // identity (the usage status) wait for both lookups.
    const ready = !loading && userLoaded;

    return (
        <AuthContext.Provider value={{user, visitorId, ready, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
